import React, {useState, JSX} from 'react';
import {IconButton, TextField, Typography} from '@mui/material';
import CreateSharpIcon from '@mui/icons-material/CreateSharp';
import {useAutocompleteStyles} from '../../../Common/MaterialUIStyles';


interface Props {
    value: string;
    update: (event: React.ChangeEvent<HTMLInputElement>) => void;
    save: (key: string) => Promise<void>;
}

export const Phone = ({ value, update, save}: Props): JSX.Element => {

    const [isEditing, setEditing] = useState(false);
    const [error, setError] = useState('');
    const autoCompleteStyles = useAutocompleteStyles();

    const submit = () => {
        save('Phone number').then(() => {
            setEditing(false);
            setError('');
        })
            .catch((e) => {
                console.error("Error saving phone number", e);
                setError('Invalid Phone Number.');
            });
    };

    const onBlur = () => {
        submit();
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            submit();
        }
    };

    return (
        <>
            <Typography gutterBottom variant='body2'>
                Phone Number
            </Typography>
            {isEditing ? (
                <TextField
                    error={error !== ''}
                    inputProps={{ 'aria-label': 'Phone Number' }}
                    autoFocus
                    fullWidth
                    type='tel'
                    name='phone'
                    onBlur={onBlur}
                    size='small'
                    helperText={"Enter a phone number, including + and the country code, for example +12125552121."}
                    onKeyDown={handleKeyDown}
                    variant='outlined'
                    value={value}
                    onChange={update}
                />
            ) : (
                <Typography onClick={() => setEditing(true)}>
                    {value}
                    <IconButton aria-label='Edit' size='small' onClick={() => setEditing(true)} className={autoCompleteStyles.iconMarginLeft}>
                        <CreateSharpIcon fontSize='small' color='primary' />
                    </IconButton>
                </Typography>
            )}
        </>
    );
}
